/* SUVENE Bewertungen Produktseite (snippets/su-reviews-cards.liquid): Kärtchen-Leiste.
   Pfeile, Wischen (Touch nativ, Maus per Ziehen), Pfeiltasten. Auto-Lauf (data-autoplay, data-speed in Sekunden):
   stoppt endgültig bei Wischen, Ziehen, Pfeil, Taste oder Aufklappen; pausiert bei Maus darüber, Fokus,
   außer Sicht oder Tab im Hintergrund. Bei "Bewegung reduzieren" kein Auto-Lauf.
   Aufklappen: je Breite wird geprüft, ob das Vollzitat in 2 Zeilen passt. Passt = Vollzitat, kein Plus.
   Passt nicht = Kurzzitat mit Plus, Antippen klappt sanft auf und zu (gesperrt, solange die Animation läuft). */
(function () {
  /* "i"-Hinweis: Hover (Desktop) und Antippen, Escape schließt; Position bleibt im Bildschirm */
  function place(w) {
    var tip = w.querySelector('.su-rv-i__tip');
    if (!tip) return;
    tip.style.setProperty('--sh', '0px');
    var r = tip.getBoundingClientRect(), vw = document.documentElement.clientWidth, sh = 0;
    if (r.left < 8) sh = 8 - r.left;
    else if (r.right > vw - 8) sh = vw - 8 - r.right;
    tip.style.setProperty('--sh', Math.round(sh) + 'px');
  }
  if (!window.__suRvInfo) {
    window.__suRvInfo = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.su-rv-i__btn') : null;
      document.querySelectorAll('.su-rv-i.is-open').forEach(function (w) {
        if (!b || w !== b.parentNode) { w.classList.remove('is-open'); w.querySelector('.su-rv-i__btn').setAttribute('aria-expanded', 'false'); }
      });
      if (!b) return;
      e.preventDefault();
      var w = b.parentNode, open = !w.classList.contains('is-open');
      w.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) place(w);
    });
    document.addEventListener('mouseover', function (e) {
      var w = e.target.closest ? e.target.closest('.su-rv-i') : null;
      if (w) place(w);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('.su-rv-i.is-open').forEach(function (w) { w.classList.remove('is-open'); });
    });
  }

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR = 320;

  function init(root) {
    if (!root || root.hasAttribute('data-ready')) return;
    root.setAttribute('data-ready', '');
    var track = root.querySelector('.su-rvc__track');
    var prev = root.querySelector('[data-su-rvc-prev]');
    var next = root.querySelector('[data-su-rvc-next]');
    var cards = track ? Array.prototype.slice.call(track.querySelectorAll('.su-rvc__card')) : [];
    if (!track || !cards.length) return;

    /* ---------- Aufklappen ---------- */
    function measure() {
      cards.forEach(function (card) {
        var q = card.querySelector('.su-rvc__q');
        card.classList.remove('is-open', 'is-fit', 'is-exp');
        q.style.height = ''; q.style.transition = ''; q.style.overflow = '';
        card.classList.add('is-measure');
        var fits = q.scrollHeight <= q.clientHeight + 2;
        card.classList.remove('is-measure');
        if (fits) {
          card.classList.add('is-fit');
          card.removeAttribute('role'); card.removeAttribute('tabindex'); card.removeAttribute('aria-expanded');
        } else {
          card.classList.add('is-exp');
          card.setAttribute('role', 'button'); card.setAttribute('tabindex', '0'); card.setAttribute('aria-expanded', 'false');
        }
      });
    }
    function toggle(card) {
      if (!card || !card.classList.contains('is-exp') || card.__busy) return;
      var q = card.querySelector('.su-rvc__q');
      var opening = !card.classList.contains('is-open');
      stop();
      var from = q.getBoundingClientRect().height, to;
      if (opening) {
        card.classList.add('is-open');
        to = q.getBoundingClientRect().height;
      } else {
        card.classList.remove('is-open');
        to = q.getBoundingClientRect().height;
        card.classList.add('is-open'); /* Volltext bleibt während des Zuklappens sichtbar */
      }
      card.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (reduce) { if (!opening) card.classList.remove('is-open'); return; }
      card.__busy = true;
      q.style.overflow = 'hidden';
      q.style.height = from + 'px';
      void q.offsetHeight;
      q.style.transition = 'height ' + DUR + 'ms cubic-bezier(.2,.7,.2,1)';
      q.style.height = to + 'px';
      setTimeout(function () {
        if (!opening) card.classList.remove('is-open');
        q.style.transition = ''; q.style.height = ''; q.style.overflow = '';
        card.__busy = false;
      }, DUR + 40);
    }

    /* ---------- Blättern und Auto-Lauf ---------- */
    function step() { return cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 8); }
    function atStart() { return track.scrollLeft < 4; }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    function update() { if (prev) prev.disabled = atStart(); if (next) next.disabled = atEnd(); }
    /* Ziel ist die echte Kante des naechsten Kaertchens (nicht ein relativer Schritt): bei Browser-Zoom oder Bruchteilen
       rastete scrollBy sonst auf dasselbe Kaertchen zurueck und der Lauf blieb nach zwei Kaertchen haengen */
    function index() { return Math.round(track.scrollLeft / step()); }
    function go(dir) {
      var i = Math.max(0, Math.min(cards.length - 1, index() + dir));
      track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }

    var auto = cards.length > 1 && root.getAttribute('data-autoplay') === 'true' && !reduce;
    var ms = Math.max(2, parseFloat(root.getAttribute('data-speed')) || 5) * 1000;
    var timer = null, stopped = false, hover = false, focus = false, visible = false;
    function tick() { if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' }); else go(1); }
    function sync() {
      var run = auto && !stopped && !hover && !focus && visible && !document.hidden;
      if (run && !timer) timer = setInterval(tick, ms);
      if (!run && timer) { clearInterval(timer); timer = null; }
      root.classList.toggle('is-auto', !!timer);
    }
    function stop() { stopped = true; sync(); }

    if (prev) prev.addEventListener('click', function () { stop(); go(-1); });
    if (next) next.addEventListener('click', function () { stop(); go(1); });
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stop(); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      var card = e.target.closest ? e.target.closest('.su-rvc__card') : null;
      if (card && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggle(card); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(-1); }
    });
    root.addEventListener('mouseenter', function () { hover = true; sync(); });
    root.addEventListener('mouseleave', function () { hover = false; sync(); });
    root.addEventListener('focusin', function () { focus = true; sync(); });
    root.addEventListener('focusout', function () { focus = false; sync(); });
    document.addEventListener('visibilitychange', sync);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; sync(); }, { threshold: 0.5 }).observe(root);
    } else { visible = true; }

    /* Maus: Ziehen zum Wischen (ab 8 px Bewegung), danach einrasten. Ein Klick ohne Ziehen klappt auf. */
    var drag = null, suppressClick = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, s: track.scrollLeft, moved: false, id: e.pointerId };
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 8) {
        drag.moved = true;
        stop();
        track.classList.add('is-drag');
        try { track.setPointerCapture(drag.id); } catch (err) {}
      }
      if (drag.moved) { e.preventDefault(); track.scrollLeft = drag.s - dx; }
    });
    function endDrag() {
      if (!drag) return;
      var moved = drag.moved;
      drag = null;
      if (!moved) return;
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 80);
      var w = step();
      track.scrollTo({ left: Math.round(track.scrollLeft / w) * w, behavior: 'smooth' });
      setTimeout(function () { track.classList.remove('is-drag'); }, 350);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('click', function (e) {
      if (suppressClick) return;
      var card = e.target.closest('.su-rvc__card');
      if (card) toggle(card);
    });

    measure();
    var lastW = track.clientWidth, rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (track.clientWidth !== lastW) { lastW = track.clientWidth; measure(); } }, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    update();
    sync();
  }
  function all() { document.querySelectorAll('[data-su-rvc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:block:select', all);
})();
